import React, { useEffect, useState } from 'react';

const money = (value) => new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format((Number(value) || 0) / 100);

export default function ShopTeaser() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    const controller = new AbortController();
    fetch('https://v-room.app/api/shop/featured?limit=4', { signal: controller.signal })
      .then((response) => response.ok ? response.json() : Promise.reject(new Error('shop unavailable')))
      .then((data) => setProducts(data.products || []))
      .catch(() => {});
    return () => controller.abort();
  }, []);
  return (
    <section id="shop" className="dl-shop-teaser">
      <div className="dl-section-heading dl-reveal">
        <div className="dl-section-code">05 / VROOM SHOP</div>
        <h2>NOŚ TO,<br /><em>CO KOCHASZ.</em></h2>
        <p>Oficjalne ubrania, naklejki i akcesoria VROOM. Limitowane dropy oraz projekty twórców naszej społeczności.</p>
      </div>
      {products.length ? <div className="dl-shop-grid">{products.map((product) => <a className="dl-shop-card dl-reveal" key={product.id} href={`https://shop.v-room.app/product/${product.slug}`}><div className="dl-shop-image">{product.images?.[0]?.url ? <img src={product.images[0].url} alt={product.images[0].alt || product.name} loading="lazy" /> : <span>VROOM</span>}{product.compareAtFrom && <b>PROMO</b>}</div><div className="dl-shop-meta"><div><small>{product.category?.name || 'VROOM'}</small><h3>{product.name}</h3></div><strong>{product.priceFrom != null ? `od ${money(product.priceFrom)}` : 'Wkrótce'}</strong></div></a>)}</div> : <div className="dl-shop-coming dl-reveal"><span>DROP 01</span><h3>PIERWSZA KOLEKCJA WKRÓTCE</h3><p>Produkty pojawią się tutaj automatycznie po publikacji w VROOM Shop.</p></div>}
      <div className="dl-shop-action dl-reveal"><a className="dl-button dl-button-primary dl-magnetic" href="https://shop.v-room.app">OTWÓRZ VROOM SHOP <span>↗</span></a></div>
    </section>
  );
}
